import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { silentHttpErrorContext } from '@shared/http';
import { AuthPermissionsDto } from '../models';

/**
 * HTTP dla gatingu uprawnień tablicy „Szukam noclegu” — tylko wywołanie API, bez stanu.
 * Kontrakt: `GET /auth/permissions` (AuthController) → `{ permissions, organizationId, orgRole }`.
 */
@Injectable({
  providedIn: 'root',
})
export class RequestBoardAccessApiService {
  private readonly http = inject(HttpClient);
  private readonly permissionsUrl = `${environment.apiUrl}auth/permissions`;

  /**
   * Scalone uprawnienia zalogowanego użytkownika (per-user ∪ rola w aktywnej org).
   * Zapytanie w tle (start aplikacji, wejście na tablicę) — błąd bez globalnego toasta;
   * wywołujący zostawia dotychczasowy stan uprawnień.
   */
  getPermissions(): Observable<AuthPermissionsDto> {
    return this.http.get<AuthPermissionsDto>(this.permissionsUrl, { context: silentHttpErrorContext() });
  }
}
